import PageHeader from "../components/PageHeader";
import AboutWhoWeAre from "../components/About-Who-We-Are";
import AboutWhyChooseUs from "../components/About-Why-Choose-Us";
import CompanyFunFacts from "../components/Company-Fun-Fact";
import OurTeam from "../components/Our-Team";
import OurBlog from "../components/Our-Blog";

const About = () => {

    return (
        <>
            <PageHeader pagetitle="About" breadcrumbMenu="Home" breadcrumbMenuActive="About Us" image="/images/about-us-banner.png" />
            <AboutWhoWeAre />
            <AboutWhyChooseUs />
            <CompanyFunFacts />
            {/* <OurTeam /> */}
            <OurBlog />
        </>
    )
}

export default About